// removed by extract-text-webpack-plugin
module.exports = {"component":"_3Dh9S8V7C0aiSgXYnx9Udy","tactTitle":"_20bGS94i5IHoXKi6-cHEUO","tactLink":"_1bmffBTjpivE9Srh_etEUP","tactTxt":"_1JdAXxFQGENFyqhdJm2PWk"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/AssureDeclare/AssureDeclare.scss
 ** module id = 1050
 ** module chunks = 0
 **/